function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.872,7.179,5.917,10.26l.042-9.194A1.07,1.07,0,0,1,7.035,0h0A1.07,1.07,0,0,1,8.1,1.076l-.041,9.192,3.076-3.04a1.07,1.07,0,0,1,1.514.006h0a1.072,1.072,0,0,1-.007,1.515l-5.049,5a.879.879,0,0,1-1.243-.007l-5-5.053a1.071,1.071,0,0,1,.007-1.514h0A1.071,1.071,0,0,1,2.872,7.179Z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-down.77cded15.svg";
export { SvgComponent as ReactComponent };